"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloneChildren = void 0;

var react_1 = require("react");

function cloneChildren(children, props, filter) {
  var array = filter ? react_1.Children.toArray(children).filter(filter) : react_1.Children.toArray(children);
  return array.map(function (child, index, arr) {
    if ((0, react_1.isValidElement)(child)) {
      if (typeof props === 'function') {
        return (0, react_1.cloneElement)(child, props(child, index, arr));
      }

      return (0, react_1.cloneElement)(child, props);
    } else {
      return child;
    }
  });
}

exports.cloneChildren = cloneChildren;